import { FC } from 'react';
import { Typography } from '@loomstateorg/shared-frontend';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';

type FeedbackProps = {
  error: string;
  success: string;
};

const Feedback: FC<FeedbackProps> = ({ error, success }) => {
  const feedBackElementClassName = useClassNames(['mb-12', success ? 'text-green-600' : 'text-accent-red']);

  if (!error && !success) return <></>;

  return (
    <Typography
      fontSize={12}
      className={feedBackElementClassName}
      data-testid={error ? 'error-message' : 'success-message'}
    >
      {error || success}
    </Typography>
  );
};

export default Feedback;
